import { useComponentTranslation } from '@core/i18n'
import { Icon, Tag } from '@core/ui-elements'
import dayjs from 'dayjs'
import { FC } from 'react'
import { FiClock } from 'react-icons/fi'
import { MdCircle } from 'react-icons/md'

import { ICoreScheduledTag } from './CoreScheduledTag.types'

export const CoreScheduledTag: FC<ICoreScheduledTag> = ({
  etaMin,
  etaMax,
  bgColor,
  showTag,
  size = 'sm',
}) => {
  const t = useComponentTranslation('CoreScheduledTag')

  if (!showTag) return null

  return (
    <Tag backgroundColor={bgColor} size={size}>
      <Icon as={FiClock} boxSize={'1rem'} /> {t('Scheduled')}{' '}
      <MdCircle size="0.375rem" /> {dayjs(etaMin).format('HH:mm')} a{' '}
      {dayjs(etaMax).format('HH:mm')}
    </Tag>
  )
}
